import React from 'react';
import { useTranslation } from 'react-i18next';
import { string, func } from 'prop-types';

// Import components
import PhoneNumberForm from './PhoneNumberForm';
import AuthenticationCodeForm from './AuthenticationCodeForm';
import Recaptcha from './Recaptcha';

// Import logic
import { usePhoneAuthentication } from '../hooks';

// Import styles
import { PhoneAuthenticationWrapper, BackButton } from '../style';

const PhoneAuthentication = ({
	setLoading,
	userCountryCode,
	hidePhoneAuthView
}) => {
	const { t } = useTranslation();

	const {
		phoneNumberFormSubmit,
		codeFormSubmit,
		isRecaptchaLoading,
		isRecaptchaSuccess,
		phoneNumberFormRef,
		codeFormRef,
		isCodeFormVisible,
		phoneNumberFormInitialValues
	} = usePhoneAuthentication({ setLoading, userCountryCode });

	return (
		<PhoneAuthenticationWrapper>
			<Recaptcha
				isRecaptchaLoading={isRecaptchaLoading}
				isCodeFormVisible={isCodeFormVisible}
			/>
			{isCodeFormVisible ? (
				<AuthenticationCodeForm
					onSubmit={codeFormSubmit}
					formRef={codeFormRef}
				/>
			) : (
				<PhoneNumberForm
					onSubmit={phoneNumberFormSubmit}
					isRecaptchaSuccess={isRecaptchaSuccess}
					formRef={phoneNumberFormRef}
					initialValues={phoneNumberFormInitialValues}
				/>
			)}
			<BackButton onClick={hidePhoneAuthView}>
				{t('common_login_firebase_go_back')}
			</BackButton>
		</PhoneAuthenticationWrapper>
	);
};

PhoneAuthentication.propTypes = {
	setLoading: func.isRequired,
	userCountryCode: string.isRequired,
	hidePhoneAuthView: func.isRequired
};

export default PhoneAuthentication;
